const companies = [
  {
    id: 1,
    name: 'Ripley Perú',
    logo: 'https://decatalogos.com/wp-content/uploads/2014/08/ripley-peru.jpg',
    url: 'https://simple.ripley.com.pe/',
  },
  {
    id: 2,
    name: 'Proeducative',
    logo: 'https://www.proeducative.com/images/logo-proeducative.png',
    url: 'https://www.proeducative.com/',
  },
  {
    id: 3,
    name: 'Plaindes',
    logo:
      'https://plaindes.com.pe/storage/information/jzj0YT0mFELIdyWwOoCCN6gaQPDgiRm1Ss2xOZUT.png',
    url: 'https://plaindes.com.pe/',
  },
  {
    id: 4,
    name: 'FRI ESAN',
    logo:
      'https://fri.com.pe/esan-capacitaciones/images/uploads/perfiles/empresa/logo/07.01.2021-xBIN6.png',
    url: 'https://fri.com.pe/esan-capacitaciones/',
  },
  {
    id: 5,
    name: 'Admisión Abc',
    logo: 'companies/abc.png',
    url: 'https://www.facebook.com/admision.abc2',
  },
  {
    id: 6,
    name: 'Rimac Seguros',
    logo:
      'https://www.rimac.com/content/dam/rimac/publica/rimac/menu/logo-red-rimac.svg',
    url: 'https://www.rimac.com/',
  },
];

export default companies;
